import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class SurveyResult extends DomainObject {
  trend;
  currentPeriodDate;

  constructor(other) {
    super();

    makeObservable(this, {
      trend: observable,
      currentPeriodDate: observable
    });

    this.merge(other);
  }
}

export default SurveyResult;
